module.exports = __webpack_public_path__ + "static/img/lv0.ef751cd6.png";